import * as tslib_1 from "tslib";
import * as React from 'react';
import { Form as FormikForm, Formik } from 'formik';
import PropTypes from 'prop-types';
import FormValueMonitor from './FormValueMonitor';
import FormStateMonitor from './FormStateMonitor';
import { emit, unregisterForm } from './FormStateStack';
/**
 * 表单
 *
 * @export
 */
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form(props) {
        var _this = _super.call(this, props) || this;
        /**
         * 表单项验证逻辑
         */
        _this.fieldValidates = [];
        _this.removeFieldValidate = function (fieldName) {
            _this.fieldValidates = _this.fieldValidates.filter(function (_a) {
                var _ = _a.fieldName;
                return _ === fieldName;
            });
            if (_this.formik) {
                var errors = _this.formik.errors;
                if (errors && errors[fieldName]) {
                    delete errors[fieldName];
                    _this.formik.setErrors(errors);
                }
            }
        };
        _this.getFormContext = function () {
            return _this.formik;
        };
        _this.reset = function () {
            var result = {};
            var defaultValues = _this.defaultValues;
            var values = _this.formik.values;
            Object.keys(values).forEach(function (key) {
                result[key] = defaultValues[key];
            });
            _this.formik.setValues(result);
        };
        _this.onFormStateChange = _this.onFormStateChange.bind(_this);
        _this.setFieldValidate = _this.setFieldValidate.bind(_this);
        _this.validate = _this.validate.bind(_this);
        _this.validateByName = _this.validateByName.bind(_this);
        if (props.name) {
            unregisterForm(props.name);
        }
        return _this;
    }
    /**
     * 设置表单项的验证逻辑
     */
    Form.prototype.setFieldValidate = function (fieldName, 
    // tslint:disable-next-line:no-any
    validate) {
        this.fieldValidates.push({
            fieldName: fieldName,
            validate: validate,
        });
    };
    Form.prototype.getChildContext = function () {
        return {
            sinouiForm: tslib_1.__assign({}, this.props, { validate: this.validate, validateByName: this.validateByName, reset: this.reset, getFormContext: this.getFormContext }),
            setFieldValidate: this.setFieldValidate,
            removeFieldValidate: this.removeFieldValidate,
        };
    };
    Form.prototype.onFormStateChange = function (formik) {
        this.formik = formik;
        this.formik.validate = this.validate;
        if (this.props.formRef) {
            this.props.formRef(formik, this);
        }
        if (this.props.name) {
            emit(this.props.name, formik);
        }
    };
    Form.prototype.validateByName = function (fieldName) {
        var _this = this;
        var _a;
        var errors = tslib_1.__assign({}, (this.formik.errors || {}));
        this.fieldValidates
            .filter(function (validate) { return validate.fieldName === fieldName; })
            .forEach(function (_a) {
            var validate = _a.validate;
            var result = validate(_this.formik.values[fieldName]);
            if (result) {
                errors[fieldName] = result;
            }
            else {
                delete errors[fieldName];
            }
        });
        this.formik.setErrors(errors);
        this.formik.setTouched((_a = {}, _a[fieldName] = true, _a));
    };
    Form.prototype.validate = function () {
        var _this = this;
        var errors = {};
        var touched = {};
        this.fieldValidates.forEach(function (_a) {
            var fieldName = _a.fieldName, validate = _a.validate;
            var result = validate(_this.formik.values[fieldName]);
            if (result) {
                errors[fieldName] = result;
            }
        });
        if (this.props.validate) {
            Object.assign(errors, this.props.validate(this.formik.values));
        }
        Object.keys(errors).forEach(function (name) { return (touched[name] = true); });
        this.formik.setErrors(errors);
        this.formik.setTouched(touched);
        return errors;
    };
    Object.defineProperty(Form.prototype, "values", {
        get: function () {
            return this.formik.values;
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line:no-any
    Form.prototype.setFieldValue = function (name, value) {
        this.formik.setFieldValue(name, value);
    };
    Object.defineProperty(Form.prototype, "isValid", {
        get: function () {
            var errors = this.validate();
            return Object.keys(errors).length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "defaultValues", {
        get: function () {
            var useDefaultValuesProps = typeof this.props.defaultValues !== 'undefined';
            return useDefaultValuesProps
                ? typeof this.props.defaultValues === 'function'
                    ? this.props.defaultValues(this.props.initialValues, this.formik.values)
                    : this.props.defaultValues
                : this.props.initialValues || {};
        },
        enumerable: true,
        configurable: true
    });
    Form.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, component = _a.component, render = _a.render, onSubmit = _a.onSubmit, initialValues = _a.initialValues, onChange = _a.onChange, enableReinitialize = _a.enableReinitialize, validateOnBlur = _a.validateOnBlur, validateOnChange = _a.validateOnChange, isInitialValid = _a.isInitialValid, labelProps = _a.labelProps, _b = _a.colon, colon = _b === void 0 ? true : _b, name = _a.name, formRef = _a.formRef, props = tslib_1.__rest(_a, ["children", "component", "render", "onSubmit", "initialValues", "onChange", "enableReinitialize", "validateOnBlur", "validateOnChange", "isInitialValid", "labelProps", "colon", "name", "formRef"]);
        var renderFn = render;
        if (!renderFn && component) {
            // tslint:disable-next-line:no-any
            renderFn = function (compProps) {
                return React.createElement(component, compProps);
            };
        }
        if (!renderFn) {
            renderFn = children;
        }
        var renderForm = function (form) { return (React.createElement(React.Fragment, null,
            onChange && React.createElement(FormValueMonitor, { action: onChange }),
            React.createElement(FormStateMonitor, { action: _this.onFormStateChange }),
            React.createElement(FormikForm, tslib_1.__assign({ noValidate: true }, props), typeof renderFn === 'function' ? renderFn(form) : renderFn))); };
        return (React.createElement(Formik, { onSubmit: onSubmit, initialValues: initialValues, enableReinitialize: enableReinitialize, isInitialValid: isInitialValid, validateOnBlur: validateOnBlur, validateOnChange: validateOnChange, validate: props.validate, render: renderForm }));
    };
    Form.childContextTypes = {
        sinouiForm: PropTypes.object,
        setFieldValidate: PropTypes.func,
        removeFieldValidate: PropTypes.func,
    };
    return Form;
}(React.Component));
export default Form;
//# sourceMappingURL=Form.js.map